import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    image: { marginBottom: 35, marginTop: 20, width: 60 },
  }),
);

export default useStyles;
